import React, { useState } from "react";
import { Button } from "react-bootstrap";
import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export function CheckoutForm() {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    const { error: confirmError } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.href
      }
    });

    if (confirmError) {
      console.error(confirmError);
      setMessage(`Payment failed: ${confirmError.message}`);
      setIsLoading(false);
      return;
    } else {
      (window as any).alert("Payment completed!");
    }
    setIsLoading(false);
  };



  return (
    <>
      <form id="payment-form" onSubmit={handleSubmit}>

        <PaymentElement id="payment-element" />
        <Button variant="outline-light" className="my-3 w-100" disabled={isLoading || !stripe || !elements} onClick={handleSubmit}>
          <span id="button-text">
            {isLoading ? <FontAwesomeIcon icon={faSpinner} spin /> : "Pay now"}
          </span>
        </Button>
        {message && <div id="payment-message">{message}</div>}
      </form>
    </>
  );
}